
export default function ProductsHero() {
  return (
    <section className="relative py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-red-900 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20equipment%20warehouse%20in%20Qatar%20with%20organized%20fire%20extinguishers%2C%20alarm%20panels%2C%20sprinkler%20systems%20and%20emergency%20lighting%20displayed%20on%20industrial%20shelving%2C%20QCDD%20approved%20fire%20protection%20products%20with%20clean%20technical%20background%20and%20red%20safety%20equipment&width=1200&height=600&seq=products-hero&orientation=landscape')`
        }}
      ></div>
      <div className="absolute inset-0 bg-black/40"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <nav className="text-sm mb-6">
            <span className="text-gray-300">Home</span>
            <i className="ri-arrow-right-s-line mx-2 text-red-400"></i>
            <span className="text-red-400 font-medium">Products</span>
          </nav>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Fire Safety Products
            <span className="block text-red-400">You Can Rely On</span>
          </h1>
          
          <p className="text-xl text-gray-200 leading-relaxed max-w-3xl mx-auto">
            At FlameGuardQA, we provide a comprehensive range of fire-safety equipment — from advanced detection systems to full-scale suppression gear and accessories. Each product meets Qatari fire-safety regulations and is engineered for reliability, efficiency and safety.
          </p>
        </div>
      </div>
    </section>
  );
}